import './okaquarium/style';
import FormStructure from './okaquarium/form_structure';

export default FormStructure;